import { Logout } from '@mui/icons-material';
import { ListItemIcon, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LogoutButtonProps {
    onClick: () => void;
}

export default function LogoutButton({ onClick }: LogoutButtonProps) {
    const { t } = useTranslation('auth');

    return (
        <MenuItem onClick={ onClick }>
            <ListItemIcon>
                <Logout fontSize="small" />
            </ListItemIcon>
            { t('logout') }
        </MenuItem>
    );
}
